exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1B4RE4vquP0Fj23uTUl3Ld{padding:1.42857rem}@media only screen and (min-width:640px){._1B4RE4vquP0Fj23uTUl3Ld{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MidtermAndFinalExam_content": "_1B4RE4vquP0Fj23uTUl3Ld"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/MidtermAndFinalExam/style.postcss
// module id = 1869
// module chunks = 0